var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSportsFootball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92314 33.7222C2.67342 33.6418 2.52901 33.5779 2.45712 33.544C2.42351 33.4725 2.36066 33.3294 2.28161 33.0824C2.14 32.64 1.99426 32.0202 1.86842 31.2428C1.75846 30.5636 1.6669 29.784 1.6052 28.9263L7.08257 34.4037C6.22626 34.3425 5.44664 34.2505 4.76671 34.1396C3.98888 34.0127 3.36728 33.8652 2.92314 33.7222Z",
    stroke: "#FCBE40",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98409 7.97782C11.1576 4.78698 15.4196 3.04937 19.6623 2.18311L33.7973 16.3181C32.9302 20.5533 31.1768 24.8051 27.997 28.0023C24.8197 31.197 20.5714 32.9502 16.3218 33.8L2.18378 19.662C3.05086 15.4268 4.80426 11.175 7.98409 7.97782ZM16.2612 24.6607L24.6612 16.2607C26.027 14.8949 26.027 12.7052 24.6612 11.3394C23.2954 9.97361 21.1057 9.97361 19.7399 11.3394L11.3399 19.7394C9.9741 21.1052 9.9741 23.2949 11.3399 24.6607C12.7057 26.0265 14.8954 26.0265 16.2612 24.6607Z",
    stroke: "#FCBE40",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0773 2.27786C33.327 2.35828 33.4714 2.42213 33.5433 2.4561C33.5769 2.52759 33.6398 2.67068 33.7188 2.91765C33.8604 3.36008 34.0062 3.97989 34.132 4.75727C34.242 5.43652 34.3335 6.21611 34.3952 7.07374L28.9179 1.59638C29.7742 1.65752 30.5538 1.74958 31.2337 1.86051C32.0115 1.9874 32.6331 2.13482 33.0773 2.27786Z",
    stroke: "#FCBE40",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSportsFootball);
export default __webpack_public_path__ + "static/media/icon-sports-football.df9577c0.svg";
export { ForwardRef as ReactComponent };